export default function Course() {
  return (
    <div class="pt-12 pb-12 gap-8 py-6 bg-[#F1E8B8] text-center">
      <div>
        <p class="font-display m-auto drop-shadow-lg bg-[#F9E784] text-[#191919] p-8 rounded-xl w-[277px]">We are offering mentoring for students who are interested in getting their amateur radio licenses!</p>
      </div>
      <div>
        <p class="font-display pt-8">If you are interested in getting your amateur radio license please reach out to <a class="text-[#1a73e8] underline" href="mailto:info@va3cua.ca">info@va3cua.ca</a>.</p>
      </div>
    </div>
  );
}
